import React from "react";
import {Link} from "react-router";

import {Button} from "@material-ui/core";

import {OrganisationId} from "common/types/organisation";
import {buildQuery} from "utils/uri";

type Props = {
  organisationId: OrganisationId;
  definitionId?: string | number | null;
  configId?: string | number | null;
  projectId?: string | number | null;
  documentId?: string | number | null;
  from?: string | null;
  to?: string | null;
};

export default function ComparisonLink({
  organisationId,
  definitionId,
  configId,
  projectId,
  documentId,
  from,
  to,
}: Props) {
  const filters = {
    ...(definitionId ? {workflow: definitionId} : {}),
    ...(configId ? {config: configId} : {}),
    ...(projectId ? {project: projectId} : {}),
    ...(documentId ? {document: documentId} : {}),
    ...(from ? {from} : {}),
    ...(to ? {to} : {}),
    reasons: "data_asset",
    maxRuns: 10,
  };
  return (
    <Link
      to={`/organisation/${organisationId}/llm_run/compare${buildQuery(
        filters,
      )}`}
    >
      <Button variant="outlined" primary={true}>
        Compare
      </Button>
    </Link>
  );
}
